import { QuestionPlanLongStayParams as Question } from "@/components/features/items/edit/plan/_shared/ui/components/stay-length/long-stay-params";

import { useDayTripPlanLongStayParams } from "./hooks";

export const QuestionDayTripPlanLongStayParams = () => {
	const { longStayParams, onSetLongStayParams } = useDayTripPlanLongStayParams();

	return <Question longStayParams={longStayParams} onSetLongStayParams={onSetLongStayParams} />;
};

QuestionDayTripPlanLongStayParams.displayName = "QuestionDayTripPlanLongStayParams";
